<!-- Bloque de Oscar «Lo que cotiza el motor ahora» (modelo de distancia). Sin modelo de distancia no pinta nada. -->
<section *ngIf="vista as v" class="db" [attr.aria-label]="'Lo que cotiza el motor ahora, ' + v.ruta">
  <p class="db__titulo">Lo que cotiza el motor ahora</p>

  <!-- Las dos puntas, el margen y el rango -->
  <div class="db__tarjetas">
    <div class="db__tarjeta db__tarjeta--peor">
      <p class="db__rotulo">{{ v.rotulos.peor }} &middot; peor para el cliente</p>
      <p class="db__valor">{{ n(v.peor) }}</p>
      <p class="db__nota">{{ v.formulaPeor }}</p>
    </div>
    <div class="db__tarjeta">
      <p class="db__rotulo">{{ v.rotulos.mejor }} &middot; mejor para el cliente</p>
      <p class="db__valor">{{ n(v.mejor) }}</p>
      <p class="db__nota">{{ v.notaMejor }}</p>
    </div>
    <div class="db__tarjeta">
      <p class="db__rotulo">{{ v.rotulos.margen }}</p>
      <p class="db__valor">{{ pct4(v.margenPct) }}</p>
      <p class="db__nota">colch&oacute;n: {{ pct(v.colchonPct) }}</p>
    </div>
    <div class="db__tarjeta">
      <p class="db__rotulo">rango que reparte la calculadora</p>
      <p class="db__valor">{{ pct4(v.rangoPct, false) }}</p>
      <p class="db__nota">del {{ v.rotulos.peor }} al {{ v.rotulos.mejor }}, por monto</p>
    </div>
  </div>

  <!-- Fuente y comisión (solo lectura: la comisión se cambia en su modal de siempre) -->
  <div class="db__fuente">
    <div class="db__campo">
      <p class="db__campo-rotulo">{{ v.rotulos.fuente }}</p>
      <p class="db__campo-valor">{{ n(v.referencia) }}</p>
      <p class="db__campo-nota"><span class="db__punto" aria-hidden="true"></span>{{ v.rotulos.fuenteNota }}</p>
    </div>
    <div class="db__campo">
      <p class="db__campo-rotulo">{{ v.rotulos.comision }}</p>
      <p class="db__campo-valor">{{ pct(v.comisionPct) }}</p>
      <p class="db__campo-nota">{{ v.rotulos.comisionNota }}</p>
    </div>
    <div class="db__campo db__campo--cuenta" *ngIf="cuentaPeor() as c">
      <p class="db__campo-rotulo">Punta desfavorable</p>
      <p class="db__campo-valor db__campo-valor--marca">{{ n(v.peor) }} {{ v.rotulos.moneda }}</p>
      <p class="db__campo-nota">{{ c }}</p>
    </div>
  </div>

  <p class="db__explica">
    <ng-container *ngIf="esVes">El promedio del P2P hace de spot, as&iacute; que el <b>margen</b> de esta ruta <b>es la comisi&oacute;n</b>.</ng-container>
    <ng-container *ngIf="!esVes">El <b>margen</b> de esta ruta es la distancia entre la tasa publicada y el spot USD/CLP.</ng-container>
    La fila de la tabla donde cae ese margen dice cu&aacute;nto se le devuelve al cliente grande &rArr;
    <b>colch&oacute;n = margen &minus; ajuste</b>.
    <ng-container *ngIf="esVes"> La tabla se comparte con la otra ruta VES.</ng-container>
    <ng-container *ngIf="v.precioCorte != null"> El monto del cliente se pasa a USDT con {{ n(v.precioCorte) }}.</ng-container>
  </p>

  <!-- La tabla da una tasa y se cobra otra (recorte por la referencia o por ida y vuelta) -->
  <div class="db__aviso" *ngIf="v.avisoTabla" role="status">{{ v.avisoTabla }}</div>
  <div class="db__aviso" *ngIf="!v.avisoTabla && v.recortado" role="status">
    El tramo grande se recort&oacute; para no cruzar la referencia ({{ n(v.referencia) }}).
  </div>
  <div class="db__aviso" *ngIf="v.idaVuelta" role="status">{{ v.idaVuelta }}</div>
  <!-- CLP→USDT se cobra desde el snapshot de la fila base: un cambio de tabla no rige al instante -->
  <p class="db__nota db__nota--suelta db__rige" *ngIf="rigeDesdeProximaBase" role="note">
    En CLP&rarr;USDT los cambios rigen desde la pr&oacute;xima tasa base (2 a 4 min).
  </p>

  <!-- Tabla de distancia -->
  <div class="db__tabla-caja" *ngIf="filas.length; else sinTabla">
    <table class="db__tabla">
      <caption class="db__oculto">Tabla de distancia {{ v.ruta }}</caption>
      <thead>
        <tr>
          <th scope="col">Min diff %</th>
          <th scope="col">Max diff %</th>
          <th scope="col" class="is-num">Ajuste %</th>
          <th scope="col" class="is-num">{{ v.rotulos.mejor }} resultante</th>
          <th scope="col"><span class="db__oculto">Fila activa</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let f of filas; let i = index; trackBy: trackIndice" [class.is-activa]="i === activa"
          [attr.aria-current]="i === activa ? 'true' : null">
          <td class="is-mono">{{ limite(f.minPct) }}</td>
          <td class="is-mono">{{ limite(f.maxPct) }}</td>
          <td class="is-num is-mono">{{ pct(f.ajustePct) }}</td>
          <td class="is-num is-mono">{{ n(resultante(i)) }}</td>
          <td class="db__marca"><ng-container *ngIf="i === activa">&larr;<span class="db__marca-texto"> activo</span></ng-container></td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #sinTabla>
    <p class="db__nota db__nota--suelta">{{ cargando ? 'Leyendo la tabla de distancia…' : 'La tabla de distancia no está disponible.' }}</p>
  </ng-template>
  <p class="db__nota db__nota--suelta" *ngIf="filas.length > 1">
    La fila activa es la tasa oficial; las dem&aacute;s muestran a cu&aacute;nto llegar&iacute;a el {{ v.rotulos.mejor }} si el margen cayera ah&iacute;.
  </p>

  <div class="db__acciones">
    <button type="button" class="db__btn" (click)="abrirEditor()">
      <mat-icon aria-hidden="true">{{ editable ? 'table_rows' : 'visibility' }}</mat-icon>
      {{ editable ? 'Editar tabla de distancia' : 'Ver tabla de distancia' }}
    </button>
    <span class="db__nota" *ngIf="esVes">Una sola tabla para USDT &rarr; VES y VES &rarr; USDT.</span>
  </div>
</section>
